export const SET_ON_BOARDING_INTERNATIONAL_MUTATION = 'setOnBoardingInternationalMutation';
export const RESET_ON_BOARDING_INTERNATIONAL_MUTATION = 'resetOnBoardingInternationalAction';

export const SET_ON_BOARDING_INTERNATIONAL_LEGAL_REPRESENTS_MUTATION = 'setOnBoardingInternationalLegalRepresentsMutation';

export const ADD_ON_BOARDING_INTERNATIONAL_EMPTY_LEGAL_REPRESENT_MUTATION = 'addOnBoardingInternationalEmptyLegalRepresentMutation';
export const REMOVE_ON_BOARDING_INTERNATIONAL_LEGAL_REPRESENT_MUTATION = 'removeOnBoardingInternationalLegalRepresentMutation';
